module.exports = __webpack_public_path__ + "img/horse.1fdcd2e7.jpg";